import { render, staticRenderFns } from "./PatientAddModal.vue?vue&type=template&id=6972ce05&scoped=true"
import script from "./PatientAddModal.vue?vue&type=script&lang=js"
export * from "./PatientAddModal.vue?vue&type=script&lang=js"
import style0 from "./PatientAddModal.vue?vue&type=style&index=0&id=6972ce05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6972ce05",
  null
  
)

export default component.exports